import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const OptionContainer = styled.div `
  padding: ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.lg};
  border: solid ${pxToRem(1)} ${theme.semantic.border.default};
`;
export const ReasonContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.md};
  background-color: ${theme.semantic.surface.secondary};
`;
